const OrderStatusFilter = [
  { text: "Todos", value: "TODOS" },
  { text: "Em Análise", value: "EM_ANALISE" },
  { text: "Orçamentos novos", value: "ORCAMENTO_NOVO" },
  { text: "Orçamentos aceitos", value: "ORCAMENTO_PRECIFICADO" },
  { text: "Novos pedidos", value: "ENVIADO" },
  { text: "Em separação", value: "SEPARANDO" },
  { text: "Aguardando Pagamento", value: "AGUARDANDOPAGAMENTO" },
  { text: "Pronto para entrega", value: "PAGO" },
  { text: "Em entrega", value: "EMENTREGA" },
  { text: "Pronto para retirada", value: "PRONTO_RETIRADA" },
  { text: "Entregues", value: "ENTREGUE" },
  { text: "Cancelados", value: "CANCELADO" }
];

const OrderStatusFilterSing = [
  { text: "Todos", value: "TODOS" },
  { text: "Orçamento novo", value: "ORCAMENTO_NOVO" },
  { text: "Orçamento aceito", value: "ORCAMENTO_PRECIFICADO" },
  { text: "Novo pedido", value: "ENVIADO" },
  { text: "Em separação", value: "SEPARANDO" },
  { text: "Aguardando Pagamento", value: "AGUARDANDOPAGAMENTO" },
  { text: "Pronto para entrega", value: "PAGO" },
  { text: "Em entrega", value: "EMENTREGA" },
  { text: "Pronto para retirada", value: "PRONTO_RETIRADA" },
  { text: "Entregue", value: "ENTREGUE" },
  { text: "Cancelado", value: "CANCELADO" },
  { text: "Em Análise", value: "EM_ANALISE" }
];

const OrderDeliveryType = [
  { text: "Todos", value: "TODOS" },
  { text: "Delivery", value: "DELIVERY" },
  { text: "Retirada", value: "RETIRADA" }
];

const OrderStatus = {
  ORCAMENTO_NOVO: "ORCAMENTO_NOVO",
  ORCAMENTO_PRECIFICADO: "ORCAMENTO_PRECIFICADO",
  ENVIADO: "ENVIADO",
  SEPARANDO: "SEPARANDO",
  AGUARDANDOPAGAMENTO: "AGUARDANDOPAGAMENTO",
  PAGO: "PAGO",
  PRONTO_RETIRADA: "PRONTO_RETIRADA",
  EMENTREGA: "EMENTREGA",
  ENTREGUE: "ENTREGUE",
  CANCELADO: "CANCELADO",
  EM_ANALISE: "EM_ANALISE"
};

const OrderStatusLabel = {
  ORCAMENTO_NOVO: "Em análise",
  ORCAMENTO_PRECIFICADO: "Orçado",
  ENVIADO: "Pedido recebido",
  SEPARANDO: "Preparando seu pedido",
  AGUARDANDOPAGAMENTO: "Aguardando pagamento",
  PAGO: "Pedido pronto para entrega",
  PRONTO_RETIRADA: "Pronto para retirada",
  EMENTREGA: "Pedido saiu para entrega",
  ENTREGUE: "Pedido entregue",
  CANCELADO: "Cancelado",
  EM_ANALISE: "Em Análise"
};

const OrderStatusColor = {
  ORCAMENTO_NOVO: "success",
  ORCAMENTO_PRECIFICADO: "success",
  ENVIADO: "success",
  SEPARANDO: "primary",
  AGUARDANDOPAGAMENTO: "warning",
  PAGO: "warning",
  PRONTO_RETIRADA: "primary",
  EMENTREGA: "primary",
  ENTREGUE: "primario",
  CANCELADO: "error",
  EM_ANALISE: "warning"
};

export default {
  OrderStatusFilter,
  OrderStatusFilterSing,
  OrderDeliveryType,
  OrderStatusLabel,
  OrderStatusColor,
  OrderStatus
};
